import AboutItem, { IAboutItem } from 'components/AboutItem/AboutItem';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  items?: IAboutItem[];
  loading: boolean;
}

const defaultItems = [{}, {}];

const createItem = (loading: boolean) => (item: IAboutItem, key: any) => (
  <AboutItem key={key} loading={loading} item={item} />
);

export const AboutTop: React.SFC<IProps> = props => (
  <Container>
    {props.items && !props.loading
      ? props.items.map(createItem(props.loading))
      : defaultItems.map(createItem(props.loading))}
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  & > * {
    flex: 0 50%;
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export default AboutTop;


// WEBPACK FOOTER //
// ./src/components/AboutTop/AboutTop.tsx